// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import QRCode from 'qrcodejs2'
import '../static/jQuery-ajaxTransport-XDomainRequest.js'
import { fun, baseData, getLan } from './assets/js/common.js'
Vue.prototype.QRCode = QRCode;
for (var key in fun) {
    Vue.prototype[key] = fun[key];
};
Vue.prototype.baseData = baseData;
Vue.prototype.getLan = getLan;
Vue.prototype.$login = 0;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js